/* global google */
'use strict';

// This sample uses the Places Autocomplete widget to:
// 1. Help the user select a place
// 2. Retrieve the address components associated with that place
// 3. Populate the form fields with those address components.
// This sample requires the Places library, Maps JavaScript API.
// Include the libraries=places parameter when you first load the API.
// For example: <script
// src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">
let autocomplete;
let address1Field;
let postalField;

function fillInAddress() {
    // Get the place details from the autocomplete object.
    const place = autocomplete.getPlace();
    let address1 = "";
    let postcode = "";

    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    // place.address_components are google.maps.GeocoderAddressComponent objects
    // which are documented at http://goo.gle/3l5i5Mr
    for (const component of place.address_components) {
        // @ts-ignore remove once typings fixed
        const componentType = component.types[0];

        switch (componentType) {
            case "street_number": {
                address1 = `${component.long_name} ${address1}`;
                break;
            }

            case "route": {
                address1 += component.short_name;
                break;
            }

            case "postal_code": {
                postcode = `${component.long_name}${postcode}`;
                break;
            }

            case "postal_code_suffix": {
                postcode = `${postcode}-${component.long_name}`;
                break;
            }

            case "locality": {
                document.querySelector('[name*="city"]').value = component.long_name;
                break;
            }

            case "administrative_area_level_1": {
                document.querySelector('[name*="state"]').value = component.short_name;
                break;
            }

            case "country": {
                document.querySelector('[name*="country"]').value = component.short_name;
                break;
            }

            default: {
                break;
            }
        }
    }

    address1Field.value = address1;
    postalField.value = postcode;
}

function initAutocomplete() {
    if ($('[name*="address1"]').length > 0) {
        address1Field = document.querySelector('[name*="address1"]');
        postalField = document.querySelector('[name*="postalCode"]');

        // Create the autocomplete object, restricting the search predictions to
        // addresses in the US and Canada.
        autocomplete = new google.maps.places.Autocomplete(address1Field, {
            componentRestrictions: { country: ["us"] },
            fields: ["address_components", "geometry"],
            types: ["address"]
        });
        // When the user selects an address from the drop-down, populate the
        // address fields in the form.
        autocomplete.addListener("place_changed", fillInAddress);
    }
}

// Full address form autocomplete Shipping, Billing, Account
$(document).ready(function () {
    initAutocomplete();
});

module.exports = {
    // Address autocomplete single field (store search)
    initAutocompleteStore: function () {
        if ($('#store-postal-code').length > 0) {
            const autocompleteFormField = document.getElementById(`store-postal-code`);
            const autocompleteForm = new google.maps.places.Autocomplete(autocompleteFormField, {
                fields: ['name', 'formatted_address', 'geometry'],
                types: ['geocode']
            });
            google.maps.event.clearInstanceListeners(autocompleteFormField);
            google.maps.event.addListener(autocompleteForm, 'place_changed', () => {
                const place = autocompleteForm.getPlace();

                if (place.formatted_address && place.geometry && place.geometry.location) {
                    $('#lat').val(place.geometry.location.lat());
                    $('#long').val(place.geometry.location.lng());
                    autocompleteFormField.value = place.formatted_address;
                    $('[name=' + autocompleteFormField.closest('form').name + ']').trigger('submit', { source: 'autocomplete' });
                }
            });
        }
    }
};
